import { useEffect, useState } from 'react';
import UsersAPI from '../../user-api';

const useUserProfilePhoto = (user) => {
  const userId = user?.id;
  const initialPhoto = user?.photoProfile;
  const [photo, setPhoto] = useState({ userId, source: initialPhoto });

  useEffect(() => {
    setPhoto({ userId, source: initialPhoto });
    if (!userId) return undefined;

    let active = true;
    let pending = false;
    const refreshPhoto = async () => {
      if (document.visibilityState === 'hidden' || pending) return;
      pending = true;
      try {
        const { data } = await UsersAPI.getUserById(userId);
        if (
          active && Number(data?.id) === Number(userId) &&
          (typeof data?.photoProfile === 'string' || data?.photoProfile === null)
        ) {
          // Keep this separate from the editable user data: replacing Formik's
          // initialValues on focus would discard unsaved administrator edits.
          setPhoto({ userId, source: data.photoProfile });
        }
      } catch (_error) {
        // Keep the last known photo if refreshing it fails.
      } finally {
        pending = false;
      }
    };

    window.addEventListener('focus', refreshPhoto);
    document.addEventListener('visibilitychange', refreshPhoto);
    return () => {
      active = false;
      window.removeEventListener('focus', refreshPhoto);
      document.removeEventListener('visibilitychange', refreshPhoto);
    };
  }, [userId, initialPhoto]);

  return photo.userId === userId ? photo.source : initialPhoto;
};

export default useUserProfilePhoto;
